import { useState } from 'react';
import { AccountOpenPosition } from 'src/@types/positions';
import { UIMarket } from '@drift/common';
import MobileTableCard from 'src/components/Tables/cards/MobileTableCard';
import MarketCellV2 from 'src/components/Tables/cells/MarketCellV2';
import { PerpMarketConfig } from '@drift-labs/sdk';
import { usePerpMarketsLookup } from 'src/hooks/perpMarkets/usePerpMarketsLookup';
import OpenPositionsTableMarginDisplay from './OpenPositionsTableMarginDisplay';
import useSettlePnls from 'src/hooks/drift-actions/useSettlePnls';
import Button from 'src/components/primitives/Button/Button';

interface Props {
	position: AccountOpenPosition;
	handleSelection: (market: PerpMarketConfig) => void;
}

export default function IsolatedBalanceOnlyMobileCard({
	position,
	handleSelection,
}: Props) {
	const uiMarket = UIMarket.createPerpMarket(position.marketIndex);
	const perpMarketsLookup = usePerpMarketsLookup();
	const { settlePnls } = useSettlePnls();
	const [isSettling, setIsSettling] = useState(false);

	const handleClickMarket = (e: React.MouseEvent<HTMLDivElement>) => {
		e.stopPropagation();
		if (perpMarketsLookup) {
			const market = perpMarketsLookup[position.marketIndex];
			if (market) handleSelection(market);
		}
	};

	return (
		<MobileTableCard.Root expanded>
			<MobileTableCard.CollapsibleHeader expanded>
				<MarketCellV2
					className="w-fit py-0"
					marketSymbol={position.marketSymbol}
					marketType={uiMarket.marketType}
					marketIndex={uiMarket.marketIndex}
					isIsolated
					onClick={handleClickMarket}
				/>
			</MobileTableCard.CollapsibleHeader>
			<MobileTableCard.CollapsibleContent>
				<div className="flex flex-col gap-y-lg">
					<div className="grid grid-cols-2 gap-lg">
						<div className="flex flex-col gap-y-xs">
							<MobileTableCard.Label>Size</MobileTableCard.Label>
							<span className="typo-h5">-</span>
						</div>
						<div className="flex flex-col items-end gap-y-xs">
							<MobileTableCard.Label>Margin</MobileTableCard.Label>
							<OpenPositionsTableMarginDisplay
								marketIndex={position.marketIndex}
							/>
						</div>
					</div>
					<div className="flex w-full">
						<Button
							size="sm"
							variant="secondary"
							className="flex-1"
							onClick={async () => {
								setIsSettling(true);
								try {
									await settlePnls(
										`isolated-balance-settle-mobile-${position.marketIndex}-${Date.now()}`,
										position.marketIndex
									);
								} finally {
									setIsSettling(false);
								}
							}}
							isLoading={isSettling}
						>
							Settle
						</Button>
					</div>
				</div>
			</MobileTableCard.CollapsibleContent>
		</MobileTableCard.Root>
	);
}
